import React from "react";
import about from '../../../assets/images/about.jpg';
import './About.css';

const About = () => {


    return (
        <section class="about section" id="about">
            <h2 class="section__title">About me</h2>
            <span class="section__subtitle">My introduction</span>

            <div class="about__container container grid">
                <img src={about} alt="" class="about__img" />


                <div class="about__data">
                    <p class="about__description">I am a student of <u>IIT-NSTU</u> and currently I am studying on 3rd year in Bachelor of Science in software engineering program.<br />As a developer I try to create something that no one else has created earlier. I use algorithms, design patterns and engineering principles to craft and mold products into something that client will love. At the same time I try to complete my work in time. So, basically there must be some creativeness into myself for putting all these places together.
                    </p>

                    <div class="about__info">
                        <div>
                            <span class="about__info-title">08+</span>
                            <span class="about__info-name">Years <br /> experience</span>
                        </div>

                        <div>
                            <span class="about__info-title">20+</span>
                            <span class="about__info-name">Completed <br /> project</span>
                        </div>

                        <div>
                            <span class="about__info-title">05+</span>
                            <span class="about__info-name">Companies <br /> worked</span>
                        </div>
                    </div>

                    <div class="about__buttons">
                        <a href={process.env.PUBLIC_URL + "/my-cv.pdf"} target="_self" download={"sourav's_CV.pdf"} class="button button--flex">
                            Download CV <i class="uil uil-download-alt button__icon"></i>
                        </a>
                    </div>
                </div>
            </div>

        </section>


    )
}

export default About